
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slugOrId]",
      function () {
        return require("private-next-pages/[...slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...slugOrId]"])
      });
    }
  